<template>
  <div>
    <b-tr v-for="table in topologyItem.Tables" :key="table.SectionTableId">
      <b-form-checkbox class="ml-3" :style="'padding-left:' + paddingLeft + 'rem'" v-model="table.Download" @change="setDownload(table, table.Download)">
        <h6>
          {{ table.DisplayName ? table.DisplayName : 'Default Section Table' }}
          <span class="smaller float-md-right mx-2"><b-badge style="font-size: 10px">Table</b-badge></span>
        </h6>
      </b-form-checkbox>
      <div :style="'padding-left:' + paddingLeft + 'rem'">
        <b-button variant="link" v-b-toggle="'collapse' + table.SectionTableId">
          Models
          <b-icon icon="chevron-down" aria-hidden="true"></b-icon>
        </b-button>
      </div>
      <b-collapse :id="'collapse' + table.SectionTableId" class="mt-2">
        <models :topologyItem="table.Models" :paddingLeft="paddingLeft + 2" @checkParent="checkParent" />
      </b-collapse>
    </b-tr>
  </div>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Models from './models.vue'

@Component({
  components: {
    'models': Models,
  },
})

export default class extends Mixins() {
  @Prop()
  public topologyItem!: any

  @Prop()
  public paddingLeft!: number

  public opened: boolean = true

  public checkParent() {
    this.topologyItem.Download = true
    this.$emit('checkParent')
  }

  public setDownload(item: any, value: boolean) {
    if (value) {
      this.checkParent()
    }
    item.Models?.forEach((m) => {
      m.Download = value
    })
  }
}
</script>
